import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-back-btn',
  templateUrl: './back-btn.component.html',
  styleUrls: ['./back-btn.component.scss']
})
export class BackBtnComponent implements OnInit {

  @Input() route;

  constructor() { }

  ngOnInit() {
  }

}
